import { render, staticRenderFns } from "./jieweishi.vue?vue&type=template&id=3f98ae2d"
import script from "./jieweishi.vue?vue&type=script&lang=js"
export * from "./jieweishi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports